








import { Component,Prop,Vue,Watch } from 'vue-property-decorator';
import store from '@/store';

@Component
export default class AutoTextarea extends Vue {
  //  currentValue = ''
  @Prop() currentValue? : string
  inputHeight= '0'
  value='';
  @Prop() id?: string;

  created(){
    if(this.currentValue!=null){
      this.value=this.currentValue;
    }
    store.state.eventHub.$on('setDrowpdownToComment',this.setDrowpdownToComment)
  }
  showList(){
      //this.shallShowList = !this.shallShowList;
  }

  onFocusOut(){
      // this.$emit('onFocusEmited',false);
  }

  setDrowpdownToComment(value: any){
    if(this.id==value.id){
      this.value=value.value;
    }
  }
  
  onTextAreaClick(){
    this.$emit('onFocusEmited',true);
  }

  get inputStyle () {
    return {
      'min-height': this.inputHeight
    }
  }

  @Watch("value")
  emitCurrentValue () {
      this.resize();
      this.$emit('input', this.value)
  }

  resize () {
        this.inputHeight = `${((this.$refs.input) as HTMLElement).scrollHeight}px`
  }

  updated(){
    console.log(this.value);
  }
}
